<template>
    <div style="margin: 20px;">
        <FilterCancelacionesPendientes @searchUpdated="getCancelacionesPendientes($event)" :loading="loading" />
        <TableCancelacionesPendientes :emisiones="emisiones" :loading="loading" :totalItems="totalItems"
            :pagination="pagination" @update:pagination="updatePagination" />
        <div class="pt-5">
            <v-row dense justify="end">
                <v-col cols="auto">
                    <v-tooltip bottom :disabled="totalItems > 0">
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <v-btn class="common-botton" color="#b11f1f" dark min-width="120" @click="abrirDialogCancelacion"
                                    :disabled="totalItems == 0 || loading" :loading="loading">
                                    Cancelar pendientes
                                </v-btn>
                            </div>
                        </template>
                        <span>No hay cancelaciones pendientes para la fecha seleccionada</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </div>
        <CancelacionesProgressDialog :isOpen.sync="dialogCancelacionAbierto" :fecha="currentForm.fecha"
            @completado="onCancelacionCompletada" @reloadData="recargarDatos" />
    </div>
</template>

<script>
import FilterCancelacionesPendientes from "@/components/cancelaciones/FilterCancelacionesPendientes.vue";
import TableCancelacionesPendientes from "@/components/cancelaciones/TableCancelacionesPendientes.vue";
import CancelacionesProgressDialog from "@/components/cancelaciones/CancelacionesProcesadasDialog.vue";
import { obtenerCancelaciones } from "@/services/cancelacionService";

export default {
    components: {
        FilterCancelacionesPendientes,
        TableCancelacionesPendientes,
        CancelacionesProgressDialog,
    },
    data() {
        return {
            currentForm: {},
            emisiones: [],
            loading: false,
            totalItems: 0,
            pagination: {
                page: 1,
                itemsPerPage: 10,
            },
            dialogCancelacionAbierto: false,
        };
    },
    methods: {
        async getCancelacionesPendientes(form) {
            if (form) {
                this.currentForm = form;
                this.pagination.page = 1;
            }

            this.loading = true;

            try {
                const payload = {
                    ...this.currentForm,
                    page: this.pagination.page,
                    itemsPerPage: this.pagination.itemsPerPage,
                };

                const res = await obtenerCancelaciones(payload);

                if (res.status === 200) {
                    this.emisiones = res.data.data;
                    this.totalItems = res.data.total;

                    if (this.totalItems === 0) {
                        this.$toast.info(
                            "No hay cancelaciones pendientes para la fecha seleccionada.",
                        );
                    }
                } else {
                    this.$toast.info(res.data.message);
                }
            } catch (error) {
                console.error(error);
                this.$toast.error(
                    "Ocurrió un error al obtener las cancelaciones pendientes",
                );
            } finally {
                this.loading = false;
            }
        },

        updatePagination(pagination) {
            this.pagination = pagination;
            if(!this.currentForm.fecha)
                return;
            this.getCancelacionesPendientes();
        },

        abrirDialogCancelacion() {
            if (!this.currentForm.fecha) {
                this.$toast.warning("Selecciona una fecha primero");
                return;
            }
            this.dialogCancelacionAbierto = true;
        },

        onCancelacionCompletada(data) {
            this.$toast.success(`Proceso completado: ${data.totalCanceladas} canceladas, ${data.totalErrores} errores`);
        },

        recargarDatos() {
            this.getCancelacionesPendientes();
        },
    },
};
</script>
